import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { LoadingService } from '../../services/loading.service';

/**
 * Componente globale per mostrare uno spinner di caricamento
 * Si sovrappone a tutta l'applicazione quando ci sono richieste HTTP in corso
 */
@Component({
  selector: 'app-global-loading',
  standalone: true,
  imports: [CommonModule, ProgressSpinnerModule],
  template: `
    @if (loadingService.isLoading()) {
      <div class="global-loading-overlay">
        <div class="loading-content">
          <p-progressSpinner
            styleClass="custom-spinner"
            strokeWidth="3"
            animationDuration="1s"
          />
          <p class="loading-text">Caricamento in corso...</p>
        </div>
      </div>
    }
  `,
  styles: [`
    .global-loading-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
      backdrop-filter: blur(2px);
    }

    .loading-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1rem;
    }

    :host ::ng-deep .custom-spinner {
      width: 60px;
      height: 60px;
    }

    :host ::ng-deep .custom-spinner .p-progress-spinner-circle {
      stroke: #ffffff;
      animation: custom-progress-spinner-dash 1.5s ease-in-out infinite;
    }

    .loading-text {
      color: white;
      font-size: 1rem;
      font-weight: 500;
      margin: 0;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    }

    @keyframes custom-progress-spinner-dash {
      0% {
        stroke-dasharray: 1, 200;
        stroke-dashoffset: 0;
      }
      50% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -35px;
      }
      100% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -124px;
      }
    }
  `]
})
export class GlobalLoadingComponent {
  public loadingService = inject(LoadingService);
}
